module.exports = __webpack_public_path__ + "img/google-logo.b7727941.svg";